export default "__VITE_ASSET__Cebef2Np__"